<template>
    <button
        :class="[
            'w-' +
                mobileSize +
                ' h-' +
                mobileSize +
                ' md:w-' +
                tabletSize +
                ' md:h-' +
                tabletSize +
                ' xl:w-' +
                desktopSize +
                ' xl:h-' +
                desktopSize,
            { 'absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2': absolute },
        ]"
        class="flex flex-row justify-center items-center rounded-full bg-white cursor-pointer transform transition-all duration-300 ease-out hover:scale-115 focus:scale-115 focus-primary-out z-10 group/1"
        :aria-label="ariaLabel"
        @click="$emit('click')">
        <span class="w-3 h-3" :class="[{ 'md:w-6 md:h-6': tabletSize > 10 }, { 'xl:w-6 xl:h-6': desktopSize > 10 }]">
            <svg class="w-full h-full" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2.33801 3.25502V20.745C2.33799 21.0044 2.4052 21.2593 2.5331 21.4849C2.66099 21.7105 2.84519 21.8991 3.06773 22.0323C3.29026 22.1654 3.54352 22.2387 3.80279 22.2447C4.06205 22.2508 4.31847 22.1896 4.54701 22.067L20.87 13.322C21.1091 13.1938 21.309 13.0032 21.4483 12.7704C21.5877 12.5376 21.6613 12.2713 21.6613 12C21.6613 11.7287 21.5877 11.4625 21.4483 11.2297C21.309 10.9969 21.1091 10.8062 20.87 10.678L4.54701 1.93302C4.31847 1.81044 4.06205 1.74921 3.80279 1.7553C3.54352 1.76139 3.29026 1.83459 3.06773 1.96777C2.84519 2.10095 2.66099 2.28955 2.5331 2.51516C2.4052 2.74077 2.33799 2.99568 2.33801 3.25502V3.25502Z"
                    :stroke="fillDefault ? '#00928E' : '#949494'"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    class="dashoffset-16 dasharray-16 transition-all duration-300 ease-out group-hover/1:dashoffset-0 group-focus/1:dashoffset-0"
                    d="M2.33801 3.25502V20.745C2.33799 21.0044 2.4052 21.2593 2.5331 21.4849C2.66099 21.7105 2.84519 21.8991 3.06773 22.0323C3.29026 22.1654 3.54352 22.2387 3.80279 22.2447C4.06205 22.2508 4.31847 22.1896 4.54701 22.067L20.87 13.322C21.1091 13.1938 21.309 13.0032 21.4483 12.7704C21.5877 12.5376 21.6613 12.2713 21.6613 12C21.6613 11.7287 21.5877 11.4625 21.4483 11.2297C21.309 10.9969 21.1091 10.8062 20.87 10.678L4.54701 1.93302C4.31847 1.81044 4.06205 1.74921 3.80279 1.7553C3.54352 1.76139 3.29026 1.83459 3.06773 1.96777C2.84519 2.10095 2.66099 2.28955 2.5331 2.51516C2.4052 2.74077 2.33799 2.99568 2.33801 3.25502V3.25502Z"
                    stroke="#00928E"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
        </span>
    </button>
</template>

<script lang="ts">
export default {
    // preserve comment: h-10 w-10 md:h-20 md:w-20 xl:h-24 xl:w-24
    props: {
        mobileSize: { type: Number, default: 10 },
        tabletSize: { type: Number, default: 20 },
        desktopSize: { type: Number, default: 24 },
        absolute: { type: Boolean, default: true },
        fillDefault: { type: Boolean, default: false },
        ariaLabel: { type: String, required: true },
    },
    emits: ['click'],
};
</script>
